import React, { useMemo } from 'react';
import commons from 'legacyfrontend/components/commons';
import useBannerNavigation from 'legacyfrontend/hooks/useBannerNavigation';
import EmpresaBannerSlot from 'frontend/features/banners/components/EmpresaBannerSlot';
import { isV1Banner } from 'frontend/features/banners';

const BannerSimple = ({ data }) => {
  const { getNavigationProps } = useBannerNavigation();
  const { title, mostrarTitulo } = data;
  const desktopImg = commons.imgUrlSliderValidator(data.imageUrl);
  const mobileImg = commons.imgUrlSliderValidator(data.imagenMobile || data.imageUrl);
  const filteredTitle = commons.filterText(title).toUpperCase();
  const navigationProps = getNavigationProps(data);

  return (
    <a
      className='block transition duration-500 shadow-sm hover:shadow-lg'
      href={navigationProps.href}
      target={navigationProps.target}
      rel='noreferrer'
    >
      <div className='relative rounded overflow-hidden'>
        <picture>
          <source media='(max-width: 768px)' srcSet={mobileImg} />
          <img
            className='bannerSimplaX3_img object-cover bg-white'
            src={desktopImg}
            alt={commons.filterText(title)}
          />
        </picture>
        {title && title !== '' && !mostrarTitulo && (
          <div
            className='
            bannerSimpleX3_img-text
            absolute bottom-0
            w-full py-7 px-4
            '
          >
            {filteredTitle}
          </div>
        )}
      </div>
    </a>
  );
};

const BannerSimpleV1 = ({ data }) => (
  <EmpresaBannerSlot data={data} templateOverride={Number(data.template) || undefined} />
);

export default function BannerSimpleX3({ data }) {
  const { banner } = data;
  const bannerListLength = (banner && banner.length) || 0;

  const renderBanner = useMemo(() => {
    let bannerList = [];

    for (let count = 0; count < bannerListLength && count <= 2; count++) {
      const item = banner[count];
      bannerList = bannerList.concat([
        isV1Banner(item) ? (
          <BannerSimpleV1 key={item.id} data={item} />
        ) : (
          <BannerSimple key={item.title} data={item} />
        ),
      ]);
    }

    return bannerList;
  }, [banner, bannerListLength]);

  return (
    <div className='container'>
      <div className='grid grid-cols-1 md:grid-cols-3 gap-5 mb-10'>{renderBanner}</div>
    </div>
  );
}
